//# sourceMappingURL=my-day-labels.interface.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/mydatepicker/dist/interfaces/my-day-labels.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-day-labels.interface.js
// module chunks = 4